import { Routes, Route, Navigate } from 'react-router-dom'
import { Landing } from './pages/Landing'
import { Dashboard } from './pages/Dashboard'
import { Login } from './pages/Login'
import { AdminUsers } from './pages/AdminUsers'
import { AdminEnrollments } from './pages/AdminEnrollments'
import { AdminEnrollmentDetail } from './pages/AdminEnrollmentDetail'
import { Canada } from './pages/regions/Canada'
import { NorthAmerica } from './pages/regions/NorthAmerica'
import { Nigeria } from './pages/regions/Nigeria'
import { WestAfrica } from './pages/regions/WestAfrica'
import { Privacy } from './pages/legal/Privacy'
import { Terms } from './pages/legal/Terms'
import { Compliance } from './pages/legal/Compliance'
import { ScrollToTop } from './components/ScrollToTop'
import { Navigation } from './components/Navigation'
import { AuthProvider, useAuth } from './contexts/AuthContext'

function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function AppContent() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        {/* Region Pages */}
        <Route path="/regions/canada" element={<Canada />} />
        <Route path="/regions/north-america" element={<NorthAmerica />} />
        <Route path="/regions/nigeria" element={<Nigeria />} />
        <Route path="/regions/west-africa" element={<WestAfrica />} />
        {/* Legal Pages */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <div className="min-h-screen bg-gray-50">
                <Navigation />
                <main className="p-4 sm:p-6">
                  <Dashboard />
                </main>
              </div>
            </ProtectedRoute>
          }
        />
        {/* Admin redirect */}
        <Route path="/admin" element={<Navigate to="/admin/enrollments" replace />} />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute>
              <div className="min-h-screen bg-gray-50">
                <Navigation />
                <main className="p-4 sm:p-6">
                  <AdminUsers />
                </main>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/enrollments"
          element={
            <ProtectedRoute>
              <div className="min-h-screen bg-gray-50">
                <Navigation />
                <main className="p-4 sm:p-6">
                  <AdminEnrollments />
                </main>
              </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/enrollments/:id"
          element={
            <ProtectedRoute>
              <div className="min-h-screen bg-gray-50">
                <Navigation />
                <main className="p-4 sm:p-6">
                  <AdminEnrollmentDetail />
                </main>
              </div>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}

export function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

